/* eslint-disable no-var */
/* globals: wc_bookings_booking_form, booking_form_params */

/**
 * External dependencies
 */
import jQuery from 'jquery';
import _ from 'underscore';

/**
 * Internal dependencies
 */
import { rrulestr } from 'rrule';
import { getClientServerTimezoneOffsetHrs } from './bookings-lib';
import { lockDatePickerForRequest } from './date-picker-interaction-lock';
import { HookApi } from './utils';

let wcBookingsTooltip = null;
let wcBookingsTooltipTimeout = null;
function initializeBookingsTooltip() {
	wcBookingsTooltip = document.createElement( 'div' );
	wcBookingsTooltip.setAttribute( 'role', 'tooltip' );
	wcBookingsTooltip.setAttribute( 'id', 'wc-bookings-tooltip' );
	wcBookingsTooltip.setAttribute( 'aria-hidden', 'true' );
	wcBookingsTooltip.classList.add( 'wc-bookings-date-tooltip' );
	wcBookingsTooltip.style.display = 'none';
	document.body.appendChild( wcBookingsTooltip );
	wcBookingsTooltip.addEventListener( 'mouseenter', () =>
		clearTimeout( wcBookingsTooltipTimeout )
	);
	wcBookingsTooltip.addEventListener(
		'mouseleave',
		hideBookingsTooltipWithDelay
	);
}
function showBookingsTooltip( cell ) {
	const content = cell.dataset.tooltipContent;
	if ( ! content ) {
		hideBookingsTooltip();
		return;
	}
	clearTimeout( wcBookingsTooltipTimeout );
	wcBookingsTooltip.textContent = content;
	wcBookingsTooltip.style.display = 'block';
	wcBookingsTooltip.setAttribute( 'aria-hidden', 'false' );
	document
		.querySelectorAll( '[aria-describedby="wc-bookings-tooltip"]' )
		.forEach( ( el ) => {
			el.removeAttribute( 'aria-describedby' );
			el.setAttribute( 'aria-expanded', 'false' );
		} );
	const focusedLink = cell.querySelector( 'a:focus' );
	const link = focusedLink || cell.querySelector( 'a' );
	if ( link ) {
		link.setAttribute( 'aria-describedby', 'wc-bookings-tooltip' );
		link.setAttribute( 'aria-expanded', 'true' );
	}
	const rect = cell.getBoundingClientRect();
	let x = rect.left + window.scrollX;
	const tooltipHeight = wcBookingsTooltip.offsetHeight;
	const spaceBelow = window.innerHeight - rect.bottom;
	let y;
	if ( tooltipHeight > spaceBelow && rect.top >= tooltipHeight ) {
		y = rect.top + window.scrollY - tooltipHeight + 1;
	} else {
		y = rect.bottom + window.scrollY - 1;
	}
	y = Math.max( window.scrollY + 10, y );
	if (
		x + wcBookingsTooltip.offsetWidth >
		window.innerWidth + window.scrollX
	) {
		x =
			window.innerWidth +
			window.scrollX -
			wcBookingsTooltip.offsetWidth -
			10;
	}
	x = Math.max( window.scrollX + 10, x );
	wcBookingsTooltip.style.left = `${ x }px`;
	wcBookingsTooltip.style.top = `${ y }px`;
}
function hideBookingsTooltipWithDelay() {
	clearTimeout( wcBookingsTooltipTimeout );
	wcBookingsTooltipTimeout = setTimeout( hideBookingsTooltip, 300 );
}
function hideBookingsTooltip() {
	if ( wcBookingsTooltip ) {
		wcBookingsTooltip.style.display = 'none';
		wcBookingsTooltip.setAttribute( 'aria-hidden', 'true' );
		document
			.querySelectorAll( '[aria-describedby="wc-bookings-tooltip"]' )
			.forEach( ( el ) => {
				el.removeAttribute( 'aria-describedby' );
				el.setAttribute( 'aria-expanded', 'false' );
			} );
	}
}
jQuery( function ( $ ) {
	let defaultDate;
	var wcBookingsLocale =
			window.navigator.userLanguage || window.navigator.language,
		wcBookingsTimeout = 0,
		currentDateRange = {},
		wcBookingsDatePicker = {
			init() {
				$( 'body' ).on(
					'click',
					'.wc-bookings-date-picker legend',
					this.toggle_calendar
				);
				$( 'body' ).on(
					'click',
					'.booking_date_year, .booking_date_month, .booking_date_day',
					this.open_calendar
				);
				$( 'body' ).on(
					'focus',
					'.booking_date_year, .booking_date_month, .booking_date_day',
					this.open_calendar
				);
				$( 'body' ).on(
					'input',
					'.booking_date_year',
					this.input_date_trigger
				);
				$( 'body' ).on(
					'change',
					'.booking_date_month, .booking_date_day',
					this.input_date_trigger
				);
				$( 'body' ).on(
					'keyup',
					'.booking_date_year, .booking_date_month, .booking_date_day',
					this.input_date_keypress
				);
				$( 'body' ).on(
					'keyup',
					'.booking_to_date_year, .booking_to_date_month, .booking_to_date_day',
					this.input_date_keypress
				);
				$( 'body' ).on(
					'change',
					'.booking_to_date_year, .booking_to_date_month, .booking_to_date_day',
					this.input_date_trigger
				);
				$( '.wc-bookings-date-picker legend' ).show();
				$( '.wc-bookings-date-picker' ).each( function () {
					var form = $( this ).closest( 'form' ),
						picker = form.find( '.picker' ),
						datePickerWrapper = $( this );
					wcBookingsDatePicker.date_picker_init( picker );
					if ( picker.data( 'display' ) === 'always_visible' ) {
						$(
							'.wc-bookings-date-picker-date-fields',
							datePickerWrapper
						).hide();
					} else {
						picker.hide();
					}
					if ( picker.data( 'is_range_picker_enabled' ) ) {
						form.find( 'p.wc_bookings_field_duration' ).hide();
						form.find(
							'.wc_bookings_field_start_date legend span.label'
						).text(
							picker.data( 'display' ) !== 'always_visible'
								? booking_form_params.i18n_dates
								: booking_form_params.i18n_start_date
						);
					}
				} );
			},
			calc_duration( picker ) {
				var form = picker.closest( 'form' ),
					datePickerWrapper = picker.closest(
						'.wc-bookings-date-picker'
					),
					unit = picker.data( 'durationUnit' );
				setTimeout( function () {
					var days = 1,
						eYear = parseInt(
							datePickerWrapper
								.find( 'input.booking_to_date_year' )
								.val(),
							10
						),
						eMonth = parseInt(
							datePickerWrapper
								.find( 'input.booking_to_date_month' )
								.val(),
							10
						),
						eDay = parseInt(
							datePickerWrapper
								.find( 'input.booking_to_date_day' )
								.val(),
							10
						),
						sYear = parseInt(
							datePickerWrapper
								.find( 'input.booking_date_year' )
								.val(),
							10
						),
						sMonth = parseInt(
							datePickerWrapper
								.find( 'input.booking_date_month' )
								.val(),
							10
						),
						sDay = parseInt(
							datePickerWrapper
								.find( 'input.booking_date_day' )
								.val(),
							10
						);
					if (
						eYear &&
						eMonth >= 0 &&
						eDay &&
						sYear &&
						sMonth >= 0 &&
						sDay
					) {
						var sDate = new Date(
								Date.UTC( sYear, sMonth - 1, sDay )
							),
							eDate = new Date(
								Date.UTC( eYear, eMonth - 1, eDay )
							);
						days = Math.floor(
							( eDate.getTime() - sDate.getTime() ) /
								( 1000 * 60 * 60 * 24 )
						);
						if ( unit === 'day' ) {
							days = days + 1;
						}
					}
					form.find( '#wc_bookings_field_duration' )
						.val( days )
						.trigger( 'change' );
				} );
			},
			open_calendar() {
				const $picker = $( this )
					.closest( '.wc-bookings-date-picker' )
					.find( '.picker:eq(0)' );
				const request = $picker.data(
					'wc-bookings-availability-request'
				);
				if (
					! $picker.hasClass( 'hasDatepicker' ) ||
					request?.state() === 'rejected'
				) {
					wcBookingsDatePicker.date_picker_init( $picker );
				}
				if (
					$picker.data( 'display' ) !== 'always_visible' &&
					$picker.is( ':hidden' )
				) {
					$picker.slideDown( function () {
						wcBookingsDatePicker.announce_calendar_visible(
							$picker[ 0 ]
						);
					} );
				}
			},
			/**
			 * Announce to screen readers that the calendar is visible.
			 * Updates the live region text only; focus stays on the date field so the user
			 * is not interrupted by focus moving to the announcer and back.
			 *
			 * @param {HTMLElement} pickerElement - The picker element (used to find the date picker wrapper and its live region).
			 * @since 3.7.0
			 */
			announce_calendar_visible( pickerElement ) {
				const message = booking_form_params.i18n_calendar_available;
				const $wrapper = $( pickerElement ).closest(
					'.wc-bookings-date-picker'
				);
				if ( ! $wrapper.length ) {
					return;
				}
				let $announcer = $wrapper.find(
					'.wc-bookings-calendar-announce'
				);
				if ( ! $announcer.length ) {
					const announcer = document.createElement( 'div' );
					announcer.className =
						'wc-bookings-calendar-announce screen-reader-text';
					announcer.setAttribute( 'role', 'status' );
					announcer.setAttribute( 'aria-live', 'polite' );
					announcer.setAttribute( 'aria-atomic', 'true' );
					$wrapper.prepend( announcer );
					$announcer = $( announcer );
				}
				const liveRegion = $announcer[ 0 ];

				// Clear and then asynchronously set the message so assistive technologies
				// detect a content change and re-announce the live region.
				liveRegion.textContent = '';
				window.requestAnimationFrame( function () {
					liveRegion.textContent = message;
				} );
			},
			toggle_calendar() {
				const $picker = $( this )
					.closest( '.wc-bookings-date-picker' )
					.find( '.picker:eq(0)' );
				const request = $picker.data(
					'wc-bookings-availability-request'
				);
				if (
					! $picker.hasClass( 'hasDatepicker' ) ||
					request?.state() === 'rejected'
				) {
					wcBookingsDatePicker.date_picker_init( $picker );
				}
				$picker.slideToggle();
			},
			input_date_keypress() {
				var $datePickerWrapper = $( this ).closest(
						'.wc-bookings-date-picker'
					),
					$picker = $datePickerWrapper.find( '.picker:eq(0)' );
				if ( $picker.data( 'is_range_picker_enabled' ) ) {
					clearTimeout( wcBookingsTimeout );
					wcBookingsTimeout = setTimeout(
						wcBookingsDatePicker.calc_duration( $picker ),
						800
					);
				}
			},
			clear_selection() {
				const formContainers = $( '.wc-bookings-booking-form' );

				// If we use setDate on the picker it will shift the selected month to the current one.

				formContainers.each( ( index, formContainer ) => {
					const $formContainer = $( formContainer );
					const form = $formContainer.closest( 'form' );

					// Clear selection
					form.find(
						'input.booking_date_year, input.booking_date_month, input.booking_date_day, input#wc_bookings_field_start_date'
					)
						.val( '' )
						.trigger( 'change' );
					form.find( '.ui-state-active' ).removeClass(
						'ui-state-active'
					);
					form.find( '.ui-datepicker-calendar td a' ).removeAttr(
						'aria-pressed'
					);

					/**
					 * @see https://github.com/woocommerce/woocommerce-bookings/pull/3277#issuecomment-1115969788
					 * for the reasoning behind the following.
					 */
					if (
						[ 'hour', 'minute' ].includes(
							wc_bookings_booking_form.get_booking_duration_unit(
								form
							)
						)
					) {
						form.find(
							'.wc-bookings-booking-form .block-picker'
						).html(
							`<li>${ wc_bookings_booking_form.sanitize_text(
								wc_bookings_booking_form.default_blocks_area_text
							) }</li>`
						);
					} else {
						// Reset block picker.
						wc_bookings_booking_form.time_picker_reset_selected(
							form.find( '.block-picker' )
						);
					}
					form.find( '.wc-bookings-booking-cost' ).hide();
				} );
			},
			input_date_trigger() {
				var $datePickerWrapper = $( this ).closest(
						'.wc-bookings-date-picker'
					),
					$picker = $datePickerWrapper.find( '.picker:eq(0)' ),
					year = parseInt(
						$datePickerWrapper
							.find( 'input.booking_date_year' )
							.val(),
						10
					),
					month = parseInt(
						$datePickerWrapper
							.find( 'input.booking_date_month' )
							.val(),
						10
					),
					day = parseInt(
						$datePickerWrapper
							.find( 'input.booking_date_day' )
							.val(),
						10
					);
				if ( year && month && day ) {
					var date = new Date( year, month - 1, day );
					$picker.datepicker( 'setDate', date );
					if ( $picker.data( 'is_range_picker_enabled' ) ) {
						var toYear = parseInt(
								$datePickerWrapper
									.find( 'input.booking_to_date_year' )
									.val(),
								10
							),
							toMonth = parseInt(
								$datePickerWrapper
									.find( 'input.booking_to_date_month' )
									.val(),
								10
							),
							toDay = parseInt(
								$datePickerWrapper
									.find( 'input.booking_to_date_day' )
									.val(),
								10
							);
						var toDate = new Date( toYear, toMonth - 1, toDay );
						if ( ! toDate || toDate < date ) {
							$datePickerWrapper
								.find( 'input.booking_to_date_year' )
								.val( '' )
								.addClass( 'error' );
							$datePickerWrapper
								.find( 'input.booking_to_date_month' )
								.val( '' )
								.addClass( 'error' );
							$datePickerWrapper
								.find( 'input.booking_to_date_day' )
								.val( '' )
								.addClass( 'error' );
						} else {
							$datePickerWrapper
								.find( 'input' )
								.removeClass( 'error' );
						}
					}
					$datePickerWrapper.triggerHandler( 'date-selected', date );
				}
			},
			select_date_trigger( date, inst ) {
				var datePickerWrapper = $( this ).closest(
						'.wc-bookings-date-picker'
					),
					picker = datePickerWrapper.find( '.picker:eq(0)' ),
					form = $( this ).closest( 'form' ),
					parsedDate = date.split( '-' ),
					startOrEndDate = picker.data( 'start_or_end_date' );
				if (
					! picker.data( 'is_range_picker_enabled' ) ||
					! startOrEndDate
				) {
					startOrEndDate = 'start';
				}
				if (
					picker.data( 'is_range_picker_enabled' ) &&
					startOrEndDate === 'end'
				) {
					var startDate = wcBookingsDatePicker.get_input_date(
						datePickerWrapper,
						''
					);
					var momentDate = moment( date );
					if ( startDate && momentDate.isBefore( startDate ) ) {
						startOrEndDate = 'start';
					}
				}

				// End date selected
				if ( startOrEndDate === 'end' ) {
					// Set min date to default
					picker.data( 'min_date', picker.data( 'o_min_date' ) );

					// Set fields
					datePickerWrapper
						.find( 'input.booking_to_date_year' )
						.val( parsedDate[ 0 ] );
					datePickerWrapper
						.find( 'input.booking_to_date_month' )
						.val( parsedDate[ 1 ] );
					datePickerWrapper
						.find( 'input.booking_to_date_day' )
						.val( parsedDate[ 2 ] )
						.trigger( 'change' );

					// Calc duration
					if ( picker.data( 'is_range_picker_enabled' ) ) {
						wcBookingsDatePicker.calc_duration( picker );
					}

					// Next click will be start date
					picker.data( 'start_or_end_date', 'start' );
					if ( picker.data( 'is_range_picker_enabled' ) ) {
						form.find(
							'.wc_bookings_field_start_date legend span.label'
						).text(
							picker.data( 'display' ) !== 'always_visible'
								? booking_form_params.i18n_dates
								: booking_form_params.i18n_clear_date_selection
						);
					}
					if ( picker.data( 'display' ) !== 'always_visible' ) {
						$( this ).hide();
					}
					// Start date selected
				} else {
					// Set min date to today
					if ( picker.data( 'is_range_picker_enabled' ) ) {
						// Store the original min date if it is not already set.
						if (
							typeof picker.data( 'o_min_date' ) === 'undefined'
						) {
							picker.data(
								'o_min_date',
								picker.data( 'min_date' )
							);
						}
						picker.data( 'min_date', date );
					}

					// Set fields
					datePickerWrapper
						.find( 'input.booking_to_date_year' )
						.val( '' );
					datePickerWrapper
						.find( 'input.booking_to_date_month' )
						.val( '' );
					datePickerWrapper
						.find( 'input.booking_to_date_day' )
						.val( '' );
					datePickerWrapper
						.find( 'input.booking_date_year' )
						.val( parsedDate[ 0 ] );
					datePickerWrapper
						.find( 'input.booking_date_month' )
						.val( parsedDate[ 1 ] );
					datePickerWrapper
						.find( 'input.booking_date_day' )
						.val( parsedDate[ 2 ] )
						.trigger( 'change' );

					// Calc duration
					if ( picker.data( 'is_range_picker_enabled' ) ) {
						wcBookingsDatePicker.calc_duration( picker );
					}

					// Next click will be end date
					picker.data( 'start_or_end_date', 'end' );
					if ( picker.data( 'is_range_picker_enabled' ) ) {
						form.find(
							'.wc_bookings_field_start_date legend span.label'
						).text( booking_form_params.i18n_end_date );
					}
					if (
						picker.data( 'display' ) !== 'always_visible' &&
						! picker.data( 'is_range_picker_enabled' )
					) {
						$( this ).hide();
					}
				}
				datePickerWrapper.triggerHandler(
					'date-selected',
					date,
					startOrEndDate
				);
				hideBookingsTooltip();
				wcBookingsDatePicker.fix_aria_current( inst );

				/**
				 * Fire action after end date select.
				 *
				 * @param {Object} fieldset Date Picker Wrapper (named Fieldset for back-compatibility).
				 *
				 * @since 1.15.79
				 */
				HookApi().doAction( 'wc_bookings_date_selected', {
					fieldset: datePickerWrapper.get( 0 ),
					date_picker: picker.get( 0 ),
				} );
			},
			date_picker_init( element ) {
				var WCDatePicker = new WCBookingsDatePicker( element );
				const minDate =
					typeof WCDatePicker.get_data_attr( 'o_min_date' ) !==
					'undefined'
						? WCDatePicker.get_data_attr( 'o_min_date' )
						: WCDatePicker.get_data_attr( 'min_date' );
				/*
				 * This prevents the calendar resetting to the current date when re-initializing.
				 *
				 * The defaultDate is set to the current date when the datepicker is initialized.
				 * As the user navigates from month to month, the defaultDate is updated to the
				 * first of the month the user has navigated to.
				 *
				 * If the resource is updated, this allows the date picker to refresh without
				 * changing the month back to the current month.
				 */
				if ( typeof defaultDate === 'undefined' ) {
					defaultDate = WCDatePicker.get_data_attr( 'default_date' );
				}
				this.monthNames = WCDatePicker.get_custom_data( 'monthNames' );
				this.dayNames = WCDatePicker.get_custom_data( 'dayNames' );

				let firstDay = WCDatePicker.get_custom_data( 'firstDay' );
				if ( booking_form_params.client_firstday ) {
					firstDay = moment().localeData().firstDayOfWeek();
					try {
						const locale = new Intl.Locale( wcBookingsLocale );
						const weekInfo =
							typeof locale.getWeekInfo === 'function'
								? locale.getWeekInfo()
								: locale.weekInfo;
						if ( weekInfo ) {
							firstDay = weekInfo.firstDay % 7;
						}
					} catch {
						// Keep the Moment fallback if Intl.Locale is missing or rejects the locale.
					}
				}

				// See https://api.jqueryui.com/datepicker/ for details.
				WCDatePicker.set_default_params( {
					onSelect: wcBookingsDatePicker.select_date_trigger,
					onUpdateDatepicker( inst ) {
						WCBookingsDatePicker.prototype.set_screen_reader_text();
						WCBookingsDatePicker.prototype.initialize_date_tooltips();
						wcBookingsDatePicker.fix_aria_current( inst );
						WCBookingsDatePicker.prototype.fix_anchor_roles( inst );
						wcBookingsDatePicker.add_button_role_to_nav( inst );
					},
					minDate,
					maxDate: WCDatePicker.get_data_attr( 'max_date' ),
					defaultDate,
					closeText: WCDatePicker.get_custom_data( 'closeText' ),
					currentText: WCDatePicker.get_custom_data( 'currentText' ),
					prevText: WCDatePicker.get_custom_data( 'prevText' ),
					nextText: WCDatePicker.get_custom_data( 'nextText' ),
					monthNames: this.monthNames,
					monthNamesShort:
						WCDatePicker.get_custom_data( 'monthNamesShort' ),
					dayNames: this.dayNames,
					dayNamesShort:
						WCDatePicker.get_custom_data( 'dayNamesShort' ),
					dayNamesMin: WCDatePicker.get_custom_data( 'dayNamesMin' ),
					firstDay,
					isRTL: WCDatePicker.get_custom_data( 'isRTL' ),
					beforeShowDay:
						WCDatePicker.maybe_load_from_cache.bind( WCDatePicker ),
					onChangeMonthYear: function ( year, month ) {
						this.get_data( year, month ).done( function () {
							element.datepicker( 'refresh' );
							wcBookingsDatePicker.fix_day_header_accessibility(
								element
							);
						} );
						defaultDate = new Date( year, month - 1, 1 );
					}.bind( WCDatePicker ),
				} );
				WCDatePicker.create();
				wc_bookings_booking_form.get_day_attributes =
					WCDatePicker.maybe_load_from_cache.bind( WCDatePicker );
			},
			/**
			 * Set ARIA attributes on datepicker anchors after a render or selection:
			 * aria-current="date" on today's cell, aria-pressed="true" on the selected cell.
			 * jQuery UI incorrectly sets aria-current="true" on the selected date; this corrects that.
			 *
			 * @param {Object} inst jQuery UI datepicker instance (provides inst.dpDiv for scoping).
			 * @return {void}
			 */
			fix_aria_current( inst ) {
				const $container =
					inst && inst.dpDiv
						? $( inst.dpDiv )
						: $( '.ui-datepicker-calendar' );
				$container
					.find( 'td a' )
					.removeAttr( 'aria-pressed' )
					.filter( '[aria-current]' )
					.removeAttr( 'aria-current' );

				// Note: the current date may not be available for booking, in which case
				// it won't have an anchor element to receive the aria-current attribute.
				$container
					.find( '.ui-datepicker-today a' )
					.attr( 'aria-current', 'date' );
				$container
					.find( 'td a.ui-state-active' )
					.attr( 'aria-pressed', 'true' );
			},
			handle_nav_keydown( event ) {
				if ( event.key === 'Enter' || event.key === ' ' ) {
					event.preventDefault();
					$( event.currentTarget ).trigger( 'click' );
				}
			},
			add_button_role_to_nav( inst ) {
				const $container =
					inst && inst.dpDiv
						? $( inst.dpDiv )
						: $( '.wc-bookings-date-picker .ui-datepicker' );
				$container
					.find( '.ui-datepicker-prev, .ui-datepicker-next' )
					.each( function () {
						const $el = $( this );
						const isDisabled = $el.hasClass( 'ui-state-disabled' );
						const isPrevious = $el.hasClass( 'ui-datepicker-prev' );
						const label = isPrevious
							? booking_form_params.i18n_previous_month
							: booking_form_params.i18n_next_month;
						$el.attr( {
							role: 'button',
							'aria-label': label,
							'aria-disabled': isDisabled ? 'true' : 'false',
							tabindex: isDisabled ? -1 : 0,
						} );
						$el.off( 'keydown.wc_bookings_date_picker_nav' );
						if ( ! isDisabled ) {
							$el.on(
								'keydown.wc_bookings_date_picker_nav',
								wcBookingsDatePicker.handle_nav_keydown
							);
						}
					} );
			},
			/**
			 * Refresh a date picker instance.
			 *
			 * @param {Object} [$picker] jQuery object of the picker to refresh.
			 *                           Defaults to the first picker on the page
			 *                           when omitted or when a non-jQuery value
			 *                           is passed.
			 */
			refresh_datepicker( $picker ) {
				if ( ! $picker || ! $picker.jquery ) {
					$picker = $( '.wc-bookings-date-picker' ).find(
						'.picker:eq(0)'
					);
				}
				$picker.datepicker( 'refresh' );
				wcBookingsDatePicker.fix_day_header_accessibility( $picker );

				/**
				 * Fire action after date picker is refreshed.
				 *
				 * @param {Object} $picker jQuery object of the date picker.
				 * @since 1.15.79
				 */
				HookApi().doAction( 'wc_bookings_date_picker_refreshed', {
					date_picker: $picker,
				} );
			},
			fix_day_header_accessibility( $picker ) {
				// Select all span elements inside datepicker headers that have a title attribute.
				const calendarHeaders = $picker.find(
					'.ui-datepicker-calendar thead th span[title]'
				);
				calendarHeaders.each( ( index, span ) => {
					// Grab the full day name from the title.
					const fullDayName = span.getAttribute( 'title' );

					// Apply it to the aria-label for screen readers.
					span.setAttribute( 'aria-label', fullDayName );

					// Remove the old title attribute.
					span.removeAttribute( 'title' );
				} );
			},
			get_input_date( datePickerWrapper, where ) {
				var year = datePickerWrapper.find(
						'input.booking_' + where + 'date_year'
					),
					month = datePickerWrapper.find(
						'input.booking_' + where + 'date_month'
					),
					day = datePickerWrapper.find(
						'input.booking_' + where + 'date_day'
					);
				if (
					year.val().length !== 0 &&
					month.val().length !== 0 &&
					day.val().length !== 0
				) {
					return year.val() + '-' + month.val() + '-' + day.val();
				}
				return '';
			},
			get_number_of_days(
				defaultNumberOfDays,
				$form,
				$picker,
				wcBookingsBookingForm
			) {
				var numberOfDays = defaultNumberOfDays;
				var wcbf = wcBookingsBookingForm;
				if (
					$form.find( '#wc_bookings_field_duration' ).length > 0 &&
					wcbf.duration_unit !== 'minute' &&
					wcbf.duration_unit !== 'hour' &&
					! $picker.data( 'is_range_picker_enabled' )
				) {
					var userDuration = $form
						.find( '#wc_bookings_field_duration' )
						.val();
					numberOfDays = numberOfDays * userDuration;
				}
				if ( numberOfDays < 1 ) {
					numberOfDays = 1;
				}
				return numberOfDays;
			},
			is_blocks_bookable( args ) {
				var bookable = args.default_availability;

				// Loop all the days we need to check for this block.
				for ( var i = 0; i < args.number_of_days; i++ ) {
					var theDate = new Date( args.start_date );
					theDate.setDate( theDate.getDate() + i );
					/* eslint-disable @wordpress/no-unused-vars-before-return */
					var year = theDate.getFullYear(),
						month = theDate.getMonth() + 1,
						day = theDate.getDate(),
						dayOfWeek = theDate.getDay();
					/* eslint-enable @wordpress/no-unused-vars-before-return */

					// Sunday is 0, Monday is 1, and so on.
					if ( dayOfWeek === 0 ) {
						dayOfWeek = 7;
					}

					// Is resource available in current date?
					// Note: resource_id = 0 is product's availability rules.
					// Each resource rules also contains product's rules.
					var resourceArgs = {
						date: theDate,
						default_availability: args.default_availability,
					};
					var resourceRules = args.availability[ args.resource_id ];

					/*
					 * If the resource ID is zero, the check is for the availability rules of the product.
					 *
					 * If the availability rules are only checked against the start date then we can bypass the
					 * checks for the second and subsequent days in the block.
					 */
					if (
						args.resource_id === 0 &&
						wc_bookings_booking_form.check_availability_against ===
							'start' &&
						i > 0
					) {
						bookable = true;
					} else {
						bookable =
							wcBookingsDatePicker.is_resource_available_on_date(
								resourceArgs,
								resourceRules
							);
					}

					// In case of automatic assignment we want to make sure at least
					// one resource is available.
					if ( args.resources_assignment === 'automatic' ) {
						var automaticResourceArgs = $.extend(
							{
								availability: args.availability,
								fully_booked_days: args.fully_booked_days,
							},
							resourceArgs
						);
						bookable = wcBookingsDatePicker.has_available_resource(
							automaticResourceArgs
						);
					}
					if ( ! bookable ) {
						return 'not_bookable_by_rules';
					}

					// Fully booked in entire block?
					var ymdIndex = year + '-' + month + '-' + day;
					if ( args.fully_booked_days[ ymdIndex ] ) {
						// If product does not have any resources, mark as bookable false.
						// OR if a product with customer defined resources found in an array, mark as bookable false.
						// This conditions fixes issues #2881 & #3453.
						// Use args.fully_booked_days consistently to avoid mixing data from multiple products on the same page.
						if (
							( args.fully_booked_days[ ymdIndex ][ 0 ] &&
								args.resource_ids.length === 0 ) ||
							( args.resource_id !== 0 &&
								args.fully_booked_days[ ymdIndex ][
									args.resource_id
								] )
						) {
							bookable = false;
						}
					}
					if ( ! bookable ) {
						break;
					}
				}
				return bookable;
			},
			rrule_cache: {},
			/**
			 * Checks rules against date to check if there are any available minutes on the date.
			 *
			 * Depending on client/server timezone offset, prev/next day will be checked for available
			 * minutes and then offsetted accordingly for timezone.
			 *
			 * @param {Object} args  Availability arguments.
			 * @param {Array}  rules Rules from lowest to highest priority.
			 *
			 * @return {boolean} Whether any minute is available.
			 */
			is_resource_available_on_date( args, rules ) {
				if ( typeof args !== 'object' || typeof rules !== 'object' ) {
					return false;
				}
				const serverOffset = getClientServerTimezoneOffsetHrs(
					args.date
				);
				const durationUnit = $( '[data-duration-unit]' ).data(
					'duration-unit'
				);
				let availableMinutes;

				// For days, skip the timezone conversion.
				if ( serverOffset === 0 || durationUnit === 'day' ) {
					availableMinutes =
						this.get_available_minutes_on_date_for_rule(
							args,
							rules
						);
				} else {
					const { date: currentDate, ...argsNoDate } = args;
					const currentDayMinutes =
						this.get_available_minutes_on_date_for_rule(
							{
								...argsNoDate,
								date: currentDate,
							},
							rules
						);
					if ( serverOffset < 0 ) {
						const nextDayDate = new Date( currentDate );
						nextDayDate.setDate( currentDate.getDate() + 1 );
						const nextDayMinutes =
							this.get_available_minutes_on_date_for_rule(
								{
									...argsNoDate,
									date: nextDayDate,
								},
								rules
							).map( ( m ) => m + 1440 );
						availableMinutes =
							currentDayMinutes.concat( nextDayMinutes );
					} else {
						const prevDayDate = new Date( currentDate );
						prevDayDate.setDate( currentDate.getDate() - 1 );
						const prevDayMinutes =
							this.get_available_minutes_on_date_for_rule(
								{
									...argsNoDate,
									date: prevDayDate,
								},
								rules
							).map( ( m ) => m - 1440 );
						availableMinutes =
							prevDayMinutes.concat( currentDayMinutes );
					}
					// Offset minutes for timezone.
					availableMinutes = availableMinutes.map(
						( m ) => m + serverOffset * 60
					);
					// Filter out minutes that are not on the current day.
					availableMinutes = availableMinutes.filter(
						( m ) => m > 0 && m < 1440
					);
				}
				return ! _.isEmpty( availableMinutes );
			},
			/**
			 * Goes through all the rules and applies them to get array of available minutes
			 *
			 * Rules are recursively applied. Rules later array will override rules earlier in the array if
			 * applicable to the block being checked.
			 *
			 * @param {Object} args  Availability arguments.
			 * @param {Array}  rules Rules from lowest to highest priority.
			 *
			 * @return {Array} Available minutes.
			 */
			get_available_minutes_on_date_for_rule( args, rules ) {
				/* eslint-disable @wordpress/no-unused-vars-before-return */
				var defaultAvailability = args.default_availability,
					year = args.date.getFullYear(),
					month = args.date.getMonth() + 1,
					// months start at 0
					day = args.date.getDate(),
					dayOfWeek = args.date.getDay(),
					week = wcBookingsDatePicker.get_week_number( args.date );
				/* eslint-enable @wordpress/no-unused-vars-before-return */

				// Sunday is 0, Monday is 1, and so on.
				if ( dayOfWeek === 0 ) {
					dayOfWeek = 7;
				}
				let minutesAvailableForDay = [];

				// `args.fully_booked_days` and `args.resource_id` only available
				// when checking 'automatic' resource assignment.
				if (
					args.fully_booked_days &&
					args.fully_booked_days[ year + '-' + month + '-' + day ] &&
					args.fully_booked_days[ year + '-' + month + '-' + day ][
						args.resource_id
					]
				) {
					return minutesAvailableForDay;
				}
				var minutesForADay = _.range( 1, 1440, 1 );
				// Ensure that the minutes are set when the all slots are available by default.
				if ( defaultAvailability ) {
					minutesAvailableForDay = minutesForADay;
				}
				$.each( rules, function ( index, rule ) {
					var type = rule.type,
						range = rule.range,
						minutesAvailableForTime;
					try {
						switch ( type ) {
							case 'months':
								if ( typeof range[ month ] !== 'undefined' ) {
									if ( range[ month ] ) {
										minutesAvailableForDay = minutesForADay;
									} else {
										minutesAvailableForDay = [];
									}
									return true; // go to the next rule
								}
								break;
							case 'weeks':
								if ( typeof range[ week ] !== 'undefined' ) {
									if ( range[ week ] ) {
										minutesAvailableForDay = minutesForADay;
									} else {
										minutesAvailableForDay = [];
									}
									return true; // go to the next rule
								}
								break;
							case 'days':
								if (
									typeof range[ dayOfWeek ] !== 'undefined'
								) {
									if ( range[ dayOfWeek ] ) {
										minutesAvailableForDay = minutesForADay;
									} else {
										minutesAvailableForDay = [];
									}
									return true; // go to the next rule
								}
								break;
							case 'custom':
								if (
									typeof range[ year ][ month ][ day ] !==
									'undefined'
								) {
									if ( range[ year ][ month ][ day ] ) {
										minutesAvailableForDay = minutesForADay;
									} else {
										minutesAvailableForDay = [];
									}
									return true; // go to the next rule
								}
								break;
							case 'rrule':
								const isAllDay =
									range.from.indexOf( ':' ) === -1;
								const currentDate = moment.utc( args.date );
								const currentDateSod = currentDate
									.clone()
									.startOf( 'day' );
								const fromDate = moment.utc( range.from );
								const toDate = moment.utc( range.to );
								const duration = moment.duration(
									toDate.diff( fromDate )
								);
								const rrule = rrulestr( range.rrule, {
									dtstart: fromDate.toDate(),
								} );
								const cacheKey =
									index +
									currentDateRange.startDate +
									currentDateRange.endDate;
								if (
									typeof wcBookingsDatePicker.rrule_cache[
										cacheKey
									] === 'undefined'
								) {
									wcBookingsDatePicker.rrule_cache[
										cacheKey
									] = rrule
										.between(
											moment
												.utc(
													currentDateRange.startDate
												)
												.subtract( duration )
												.subtract( 1, 'days' )
												.toDate(),
											moment
												.utc( currentDateRange.endDate )
												.subtract( duration )
												.add( 1, 'days' )
												.toDate(),
											true
										)
										.map(
											( occurrence ) =>
												new moment( occurrence )
										);
								}
								wcBookingsDatePicker.rrule_cache[
									cacheKey
								].forEach( ( occurrence ) => {
									const occurrenceSod = occurrence
										.clone()
										.startOf( 'day' );
									const endOccurrence = occurrence
										.clone()
										.add( duration );
									const endOccurrenceSod = endOccurrence
										.clone()
										.startOf( 'day' );
									if (
										currentDateSod.isSameOrAfter(
											occurrenceSod
										) &&
										currentDateSod.isBefore(
											endOccurrenceSod
										)
									) {
										if ( isAllDay ) {
											minutesAvailableForDay = range.rule
												? minutesForADay
												: [];
										} else if (
											currentDateSod.isSame(
												occurrenceSod
											)
										) {
											const minutesFromStartOfDay = moment
												.duration(
													occurrence.diff(
														occurrenceSod
													)
												)
												.asMinutes();
											minutesAvailableForTime = _.range(
												minutesFromStartOfDay,
												minutesFromStartOfDay +
													duration.asMinutes(),
												1
											);
											if ( range.rule ) {
												minutesAvailableForDay =
													_.union(
														minutesAvailableForDay,
														minutesAvailableForTime
													);
											} else {
												minutesAvailableForDay =
													_.difference(
														minutesAvailableForDay,
														minutesAvailableForTime
													);
											}
										} else if (
											currentDateSod.isAfter(
												occurrenceSod
											) &&
											currentDateSod.isBefore(
												endOccurrenceSod
											)
										) {
											// Event is a multi-day event with start and end time but current day is fully inside the start day and end days
											minutesAvailableForDay = range.rule
												? minutesForADay
												: [];
										} else if (
											currentDateSod.isSame(
												endOccurrenceSod
											)
										) {
											// Event is multi-day and current day is the last day of event. Find how many minutes there are before end time.
											minutesAvailableForTime = _.range(
												1,
												moment
													.duration(
														endOccurrence.diff(
															endOccurrenceSod
														)
													)
													.asMinutes(),
												1
											);
											if ( range.rule ) {
												minutesAvailableForDay =
													_.union(
														minutesAvailableForDay,
														minutesAvailableForTime
													);
											} else {
												minutesAvailableForDay =
													_.difference(
														minutesAvailableForDay,
														minutesAvailableForTime
													);
											}
										}
									}
								} );
								break;
							case 'time':
							case 'time:1':
							case 'time:2':
							case 'time:3':
							case 'time:4':
							case 'time:5':
							case 'time:6':
							case 'time:7':
								if (
									dayOfWeek === range.day ||
									range.day === 0
								) {
									var fromHour = parseInt(
										range.from.split( ':' )[ 0 ],
										10
									);
									var fromMinute = parseInt(
										range.from.split( ':' )[ 1 ],
										10
									);
									var toHour = parseInt(
										range.to.split( ':' )[ 0 ],
										10
									);
									var toMinute = parseInt(
										range.to.split( ':' )[ 1 ],
										10
									);

									// each minute in the day gets a number from 1 to 1440
									var fromMinuteNumber =
										fromMinute + fromHour * 60;
									var toMinuteNumber = toMinute + toHour * 60;
									minutesAvailableForTime = _.range(
										fromMinuteNumber,
										toMinuteNumber,
										1
									);
									if ( range.rule ) {
										minutesAvailableForDay = _.union(
											minutesAvailableForDay,
											minutesAvailableForTime
										);
									} else {
										minutesAvailableForDay = _.difference(
											minutesAvailableForDay,
											minutesAvailableForTime
										);
									}
									return true;
								}
								break;
							case 'time:range':
							case 'custom:daterange':
								range = range[ year ][ month ][ day ];
								var rangeFromHour = parseInt(
									range.from.split( ':' )[ 0 ],
									10
								);
								var rangeFromMinute = parseInt(
									range.from.split( ':' )[ 1 ],
									10
								);
								var rangeToHour = parseInt(
									range.to.split( ':' )[ 0 ],
									10
								);
								var rangeToMinute = parseInt(
									range.to.split( ':' )[ 1 ],
									10
								);

								// each minute in the day gets a number from 1 to 1440
								var rangeFromMinuteNumber =
									rangeFromMinute + rangeFromHour * 60;
								var rangeToMinuteNumber =
									rangeToMinute + rangeToHour * 60;
								minutesAvailableForTime = _.range(
									rangeFromMinuteNumber,
									rangeToMinuteNumber,
									1
								);
								if ( range.rule ) {
									minutesAvailableForDay = _.union(
										minutesAvailableForDay,
										minutesAvailableForTime
									);
								} else {
									minutesAvailableForDay = _.difference(
										minutesAvailableForDay,
										minutesAvailableForTime
									);
								}
								break;
						}
					} catch {
						return true; // go to the next rule
					}
				} );
				return minutesAvailableForDay;
			},
			get_week_number( date ) {
				return moment( date ).format( 'W' );
			},
			has_available_resource( args ) {
				for ( var resourceId in args.availability ) {
					resourceId = parseInt( resourceId, 10 );

					// Skip resource_id '0' that has been performed before.
					if ( resourceId === 0 ) {
						continue;
					}
					var resourceRules = args.availability[ resourceId ];
					args.resource_id = resourceId;
					if (
						wcBookingsDatePicker.is_resource_available_on_date(
							args,
							resourceRules
						)
					) {
						return true;
					}
				}
				return false;
			},
		};

	/**
	 * Represents a jQuery UI DatePicker.
	 *
	 * @class
	 * @version 1.10.11
	 * @since   1.10.11
	 * @param {Object} element - jQuery object for the picker that was initialized.
	 */
	var WCBookingsDatePicker = function WCBookingsDatePicker( element ) {
		this.$picker = $( element );
		this.$form = this.$picker.closest( 'form, .cart' );
		this.customData = {};
		this.opts = {
			cache: false,
		};
		this.cache = {
			data: {},
			attributes: {},
		};
		$.each(
			wc_bookings_booking_form,
			function ( key, val ) {
				this.customData[ key ] = val;
			}.bind( this )
		);
		$.each(
			booking_form_params,
			function ( key, val ) {
				this.customData[ key ] = val;
			}.bind( this )
		);
		if (
			this.customData.cache_ajax_requests &&
			( this.customData.cache_ajax_requests.toLowerCase() === 'true' ||
				this.customData.cache_ajax_requests.toLowerCase() === 'false' )
		) {
			this.opts.cache =
				this.customData.cache_ajax_requests.toLowerCase() === 'true';
		}

		// Multiple global objects get defined on client side when more than one booking product is used per page.
		// For this reason, the localized param value is set to the last defined global object which creates issue with booking calendars.
		// And the global object always refer to the recently loaded booking product. To fix issue, we are adding product specific settings to customData.
		// https://github.com/woocommerce/woocommerce-bookings/issues/1636
		this.customData.product_id =
			wc_bookings_booking_form.get_booking_product_id( element );
		this.customData.booking_duration =
			wc_bookings_booking_form.get_booking_duration( element );
		this.customData.booking_min_duration =
			wc_bookings_booking_form.get_booking_min_duration( element );
		this.customData.booking_max_duration =
			wc_bookings_booking_form.get_booking_max_duration( element );
		this.customData.check_availability_against =
			wc_bookings_booking_form.get_booking_check_availability_against(
				element
			);
		this.customData.default_availability =
			wc_bookings_booking_form.get_booking_default_availability(
				element
			);
		this.customData.duration_type =
			wc_bookings_booking_form.get_booking_duration_type( element );
		this.customData.booking_duration_type =
			wc_bookings_booking_form.get_booking_duration_type( element );
		this.customData.duration_unit =
			wc_bookings_booking_form.get_booking_duration_unit( element );
		this.customData.resources_assignment =
			wc_bookings_booking_form.get_booking_resources_assignment(
				element
			);
		this.customData.resource_ids =
			wc_bookings_booking_form.get_booking_resource_ids( element );
		if ( ! this.$picker.length ) {
		}
	};

	/**
	 * Creates the DatePicker referenced by initializing the first data call.
	 *
	 * @version 1.10.11
	 * @since   1.10.11
	 */
	WCBookingsDatePicker.prototype.create = function create() {
		var year = parseInt(
			this.$form.find( 'input.booking_date_year' ).val(),
			10
		);
		var month = parseInt(
			this.$form.find( 'input.booking_date_month' ).val(),
			10
		);
		var day = parseInt(
			this.$form.find( 'input.booking_date_day' ).val(),
			10
		);
		this.$picker
			.empty()
			.removeClass( 'hasDatepicker' )
			.datepicker( this.get_default_params() );
		$( '.ui-datepicker-current-day' ).removeClass(
			'ui-datepicker-current-day'
		);
		if ( year && month && day ) {
			this.$picker.datepicker(
				'setDate',
				new Date( year, month - 1, day )
			);
		}
		var pickerMonth = this.$picker.datepicker( 'getDate' ).getMonth() + 1;
		var pickerYear = this.$picker.datepicker( 'getDate' ).getFullYear();
		this.get_data( pickerYear, pickerMonth ).done( function () {
			wcBookingsDatePicker.refresh_datepicker();
		} );
	};

	/**
	 * If caching is being requested beforeShowDay will use this method to load styles from cache if available.
	 *
	 * @version 1.10.11
	 * @since   1.10.11
	 * @param {Object} date - Date to apply attributes to.
	 */
	WCBookingsDatePicker.prototype.maybe_load_from_cache =
		function maybeLoadFromCache( date ) {
			var cacheKey = date.getTime();
			var defaultClass =
				this.customData.default_availability === '1'
					? 'bookable'
					: 'not-bookable';
			var cachedAttributes = this.cache.attributes[ cacheKey ];

			// We'll append these classes to the element, then after it gets rendered,
			// we'll add a screen reader text element with the date information for
			// better accessibility.
			let dateClassNames = [
				'date-year-' + date.getFullYear(),
				'date-month-' + date.getMonth(),
				'date-date-' + date.getDate(),
				'date-day-' + date.getDay(),
			];
			dateClassNames = dateClassNames.join( ' ' );

			// Ensure that even the default attributes case includes the date-* classes
			// so that accessibility helpers (like screen reader text) can always rely
			// on them, even before bookingsData has loaded.
			var attributes = [ false, defaultClass + ' ' + dateClassNames, '' ];
			if ( cachedAttributes ) {
				cachedAttributes = [
					cachedAttributes.selectable,
					cachedAttributes.class.join( ' ' ) + ' ' + dateClassNames,
					cachedAttributes.title,
				];
			} else if ( this.bookingsData ) {
				var attrs = this.getDateElementAttributes( date );
				attributes = [
					attrs.selectable,
					attrs.class.join( ' ' ) + ' ' + dateClassNames,
					attrs.title,
				];
			}
			return cachedAttributes || attributes;
		};

	/**
	 * Returns the default parameters.
	 *
	 * @version 1.10.11
	 * @since   1.10.11
	 */
	WCBookingsDatePicker.prototype.get_default_params =
		function getDefaultParams() {
			return this.defaultParams || {};
		};

	/**
	 * Set and override the default parameters.
	 *
	 * @version 1.10.11
	 * @since   1.10.11
	 * @param {Object} params - Parameters to be set or overridden.
	 */
	WCBookingsDatePicker.prototype.set_default_params =
		function setDefaultParams( params ) {
			var _defaultParams = {
				showWeek: false,
				showOn: false,
				numberOfMonths: 1,
				showButtonPanel: false,
				showOtherMonths: true,
				selectOtherMonths: true,
				gotoCurrent: true,
				dateFormat: $.datepicker.ISO_8601,
			};
			if ( typeof params !== 'object' ) {
				throw new Error(
					'Cannot set params with typeof ' + typeof params
				);
			}
			this.defaultParams = $.extend( _defaultParams, params ) || {};
		};

	/**
	 * Get the data from the server for a block of time.
	 *
	 * @since   1.10.11
	 * @param {string} year  - Year being requested.
	 * @param {string} month - Month being requested.
	 * @return {Object} Deferred object to be resolved after the http request
	 */
	WCBookingsDatePicker.prototype.get_data = function getData( year, month ) {
		/**
		 * Overlay styles when jQuery.block is called to block the DOM.
		 */
		var blockUIOverlayCSS = {
			background: '#fff',
			opacity: 0.6,
		};

		/**
		 * Get a date range based on the start date.
		 *
		 * @since   1.10.11
		 * @param {string} startDate - Optional start date to get the date range from.
		 * @return {Object} Object referencing the start date and end date for the range calculated.
		 */
		var getDateRange = function ( startDate ) {
			if ( ! startDate ) {
				startDate = new Date( [ year, month, '01' ].join( '/' ) );
			}
			var range = this.get_number_of_days_in_month( month );
			return this.get_padded_date_range( startDate, range );
		}.bind( this );
		var deferred = $.Deferred();
		var dateRange = getDateRange();
		var cacheKey =
			dateRange.startDate.getTime() + '-' + dateRange.endDate.getTime();
		if ( this.opts.cache && this.cache.data[ cacheKey ] ) {
			deferred.resolveWith( this, [
				dateRange,
				this.cache.data[ cacheKey ],
			] );
		} else {
			var resourceId =
				parseInt(
					this.$form
						.find( 'select#wc_bookings_field_resource' )
						.val(),
					10
				) || 0;
			var params = {
				product_id: this.get_custom_data( 'product_id' ),
				'wc-ajax': 'wc_bookings_find_booked_day_blocks',
				security: this.$form.data( 'nonce' ),
				resource_id: resourceId,
			};
			this.$picker.block( {
				message: null,
				overlayCSS: blockUIOverlayCSS,
			} );
			if ( booking_form_params.timezone_conversion ) {
				params.timezone_offset = getClientServerTimezoneOffsetHrs(
					dateRange.startDate
				);
				$( '#timezone_offset' ).val( params.timezone_offset );
			}
			params.min_date = moment( dateRange.startDate ).format(
				'YYYY-MM-DD'
			);
			params.max_date = moment( dateRange.endDate ).format(
				'YYYY-MM-DD'
			);
			$( '#min_date' ).val( params.min_date );
			$( '#max_date' ).val( params.max_date );
			var availabilityRequest = $.ajax( {
				context: this,
				url: wc_bookings_date_picker_args.ajax_url,
				method: 'GET',
				data: params,
			} ).done(
				function ( data ) {
					if ( 'old_availability' in data && data.old_availability ) {
						if ( $( '#old_availability_served' ).length === 0 ) {
							const oldAvailability =
								document.createElement( 'p' );
							oldAvailability.setAttribute(
								'id',
								'old_availability_served'
							);
							oldAvailability.textContent =
								booking_form_params.i18n_old_availability;
							$( oldAvailability ).insertBefore(
								'#wc-bookings-booking-form'
							);
						}
					} else {
						$( '#old_availability_served' ).remove();
					}
					this.bookingsData = this.bookingsData || {};
					$.each(
						data,
						function ( key, val ) {
							if (
								Array.isArray( val ) ||
								typeof val === 'object'
							) {
								var emptyType = Array.isArray( val ) ? [] : {};
								this.bookingsData[ key ] =
									this.bookingsData[ key ] || emptyType;
								$.extend( this.bookingsData[ key ], val );
							} else {
								this.bookingsData[ key ] = val;
							}
						}.bind( this )
					);
					wc_bookings_booking_form.wc_bookings_date_picker.bookingsData =
						this.bookingsData;
					this.cache.data[ cacheKey ] = data;
					if ( ! year && ! month && this.bookingsData.min_date ) {
						dateRange = getDateRange(
							this.get_default_date( this.bookingsData.min_date )
						);
					}
					deferred.resolveWith( this, [ dateRange, data ] );
				}.bind( this )
			);
			this.$picker.data(
				'wc-bookings-availability-request',
				availabilityRequest
			);
			availabilityRequest.always(
				function () {
					this.$picker.unblock();
				}.bind( this )
			);
			lockDatePickerForRequest(
				this.$picker.get( 0 ),
				availabilityRequest
			);
		}
		return deferred;
	};

	/**
	 * Gets the default date
	 *
	 * @param {Object} minBookableDate Minimum bookable-date offset.
	 * @version 1.10.11
	 * @since   1.10.11
	 * @return {Date}  Default date
	 */
	WCBookingsDatePicker.prototype.get_default_date = function getDefaultDate(
		minBookableDate
	) {
		var initialDefaultDate;
		var defaultDateFromData = this.$picker
			.data( 'default_date' )
			.split( '-' );
		// We change the day to be 31, as default_date defaults to the current day,
		// but we want to go as far as to the end of the current month.
		defaultDateFromData[ 2 ] = '31';
		var modifier = 1;

		// If for some reason the default_date didn't get or set incorrectly we should
		// try to fix it even though it may be indicative somewith else has gone wrong
		// on the backend.
		initialDefaultDate =
			defaultDateFromData.length !== 3
				? new Date()
				: new Date( defaultDateFromData );

		// The server will sometimes return a min_bookable_date with the data request
		// If that happens we need to modify the default date to start from this
		// modified date.
		if ( minBookableDate ) {
			switch ( minBookableDate.unit ) {
				case 'month':
					modifier = 30;
					break;
				case 'week':
					modifier = 7;
					break;
			}
			modifier = modifier * minBookableDate.value;
			initialDefaultDate.setDate(
				initialDefaultDate.getDate() + modifier
			);
		}
		return initialDefaultDate;
	};

	/**
	 * Get number of days in a month
	 *
	 * @version 1.10.11
	 * @since   1.10.11
	 * @param {number} [ month = currentMonth ] - The month in a 1 based index to get the number of days for.
	 * @return {number} Number of days in the month.
	 */
	WCBookingsDatePicker.prototype.get_number_of_days_in_month =
		function getNumberOfDaysInMonth( month ) {
			var currentDate = this.get_default_date();
			month = month || currentDate.getMonth() + 1;
			return new Date( currentDate.getFullYear(), month, 0 ).getDate();
		};

	/**
	 * Get custom data that was set by the server prior to rendering the client.
	 *
	 * @version 1.10.11
	 * @since   1.10.11
	 * @param {string} key - Custom data attribute to get.
	 */
	WCBookingsDatePicker.prototype.get_custom_data = function getCustomData(
		key
	) {
		if ( ! key ) {
			return;
		}
		return this.customData[ key ] || null;
	};

	/**
	 * Get data attribute set on the $picker element.
	 *
	 * @version 1.10.11
	 * @since   1.10.11
	 * @param {string} attr - Data attribute to get.
	 */
	WCBookingsDatePicker.prototype.get_data_attr = function getDataAttr(
		attr
	) {
		if ( ! attr ) {
			return;
		}
		return this.$picker.data( attr );
	};

	/**
	 * Gets a date range with a padding in days on either side of the range.
	 *
	 * @version 1.10.11
	 * @since   1.10.11
	 * @param {Date}   date        - Date to start from.
	 * @param {number} rangeInDays - Number of days to build for the range.
	 * @param {number} padInDays   - Number of days to pad on either side of the range.
	 */
	WCBookingsDatePicker.prototype.get_padded_date_range =
		function getPaddedDateRange( date, rangeInDays, padInDays ) {
			date = date || this.get_default_date();
			rangeInDays = rangeInDays || 30;
			padInDays = padInDays || 7;
			var currentDate = new Date();
			var isCurrentDayToday = date < currentDate;
			var startDate = new Date(
				date.setDate( isCurrentDayToday ? currentDate.getDate() : '01' )
			); // We dont go back further than today
			var endDate = new Date( startDate.getTime() );
			startDate.setDate(
				startDate.getDate() - ( isCurrentDayToday ? 0 : padInDays )
			); // No reason to pad the left if the date is today
			endDate.setDate( endDate.getDate() + ( rangeInDays + padInDays ) );
			if ( startDate < currentDate ) {
				startDate = currentDate;
			}
			return {
				startDate,
				endDate,
			};
		};

	/**
	 * Gets the date element attributes. This was formerly called is_bookable but changed names to more accurately reflect its new purpose.
	 *
	 * @version 1.10.11
	 * @param {Date} date Date to inspect.
	 * @since   1.10.11
	 * @return {Object} Attributes computed for the date.
	 */
	WCBookingsDatePicker.prototype.getDateElementAttributes =
		function getDateElementAttributes( date ) {
			var attributes = {
				class: [],
				title: '',
				selectable: true,
				bookable: true,
			};
			var momentDate = moment( date );
			var resourceId =
				this.$form.find( 'select#wc_bookings_field_resource' ).val() > 0
					? this.$form
							.find( 'select#wc_bookings_field_resource' )
							.val()
					: 0;
			var year = date.getFullYear();
			var month = date.getMonth() + 1;
			var day = date.getDate();
			var dayOfWeek = date.getDay();
			var ymdIndex = year + '-' + month + '-' + day;
			var today = new Date();

			// Unavailable days?
			if (
				this.bookingsData.unavailable_days &&
				this.bookingsData.unavailable_days[ ymdIndex ] &&
				this.bookingsData.unavailable_days[ ymdIndex ][ resourceId ]
			) {
				attributes.title = booking_form_params.i18n_date_unavailable;
				attributes.bookable = false;
				attributes.selectable = false;
				attributes.class.push( 'not_bookable' );
			}

			// Unavailable days when the resources is automatically assigned.
			if (
				wc_bookings_booking_form.resources_assignment === 'automatic' &&
				this.bookingsData.unavailable_days &&
				this.bookingsData.unavailable_days[ ymdIndex ] &&
				Object.keys( this.bookingsData.unavailable_days[ ymdIndex ] )
					.length === wc_bookings_booking_form.resource_ids.length
			) {
				attributes.title = booking_form_params.i18n_date_unavailable;
				attributes.bookable = false;
				attributes.selectable = false;
				attributes.class.push( 'not_bookable' );
				attributes.class.push( 'not_bookable_by_resources' );
			}

			// Buffer days?
			if (
				this.bookingsData.buffer_days &&
				this.bookingsData.buffer_days[ ymdIndex ]
			) {
				// If "resources_assignment" is set to customer selected, check if the selected resource has a buffer day for a particular date.
				// If "resources_assignment" is set to "automatic", make the date not bookable if it is a buffer day for all available resources.
				if (
					this.bookingsData.buffer_days[ ymdIndex ][ 0 ] ||
					this.bookingsData.buffer_days[ ymdIndex ][ resourceId ] ||
					( this.customData.resources_assignment === 'automatic' &&
						Object.keys( this.bookingsData.buffer_days[ ymdIndex ] )
							.length === this.customData.resource_ids.length )
				) {
					attributes.title =
						booking_form_params.i18n_date_unavailable;
					attributes.bookable = false;
					attributes.selectable = false;
					attributes.class.push( 'not_bookable' );
				}
			}

			// Restricted days?
			if (
				this.bookingsData.restricted_days &&
				undefined === this.bookingsData.restricted_days[ dayOfWeek ]
			) {
				attributes.title = booking_form_params.i18n_date_unavailable;
				attributes.bookable = false;
				attributes.selectable = false;
				attributes.class.push( 'not_bookable' );
			}
			if ( momentDate.isBefore( today, 'day' ) ) {
				attributes.title = booking_form_params.i18n_date_unavailable;
				attributes.bookable = false;
				attributes.selectable = false;
				attributes.class.push( 'not_bookable' );
			}
			var numberOfDays = wcBookingsDatePicker.get_number_of_days(
				this.customData.booking_duration,
				this.$form,
				this.$picker,
				wc_bookings_booking_form
			);
			var blockArgs = {
				start_date: date,
				number_of_days:
					wc_bookings_booking_form.check_availability_against ===
					'start'
						? 1
						: numberOfDays,
				fully_booked_days: this.bookingsData.fully_booked_days,
				availability: this.bookingsData.availability_rules,
				default_availability: this.customData.default_availability,
				resource_id: resourceId,
				resource_ids: this.customData.resource_ids,
				resources_assignment: this.customData.resources_assignment,
			};
			var bookable = wcBookingsDatePicker.is_blocks_bookable( blockArgs );
			// Is this date itself closed by availability rules? Bookings made before
			// the rule changed must not label it fully or partially booked. Ignore
			// bookings here: automatic resource checks also fail on occupied days.
			var unavailableByRules =
				bookable === 'not_bookable_by_rules' &&
				wcBookingsDatePicker.is_blocks_bookable(
					$.extend( {}, blockArgs, {
						number_of_days: 1,
						fully_booked_days: {},
					} )
				) === 'not_bookable_by_rules';
			if ( bookable === 'not_bookable_by_rules' ) {
				attributes.class.push( 'not_bookable_by_rules' );
				bookable = false;
			}

			// Fully booked?
			if (
				! unavailableByRules &&
				this.bookingsData.fully_booked_days[ ymdIndex ]
			) {
				// If product does not have any resources, mark as fully booked if found in the array.
				// OR if a product with customer defined resources found in an array, mark as fully booked.
				// This conditions fixes issues #2881 & #3453.
				if (
					( this.bookingsData.fully_booked_days[ ymdIndex ][ 0 ] &&
						this.customData.resource_ids.length === 0 ) ||
					( resourceId !== 0 &&
						this.bookingsData.fully_booked_days[ ymdIndex ][
							resourceId
						] )
				) {
					attributes.title =
						booking_form_params.i18n_date_fully_booked;
					attributes.selectable = false;
					attributes.class.push( 'fully_booked' );
					return attributes;
				} else if (
					this.customData.resources_assignment === 'automatic'
				) {
					attributes.class.push( 'partial_booked' );
				}
			}

			// Apply partially booked CSS class.
			if (
				! unavailableByRules &&
				this.bookingsData.partially_booked_days &&
				this.bookingsData.partially_booked_days[ ymdIndex ]
			) {
				if (
					this.customData.resources_assignment === 'automatic' ||
					this.bookingsData.partially_booked_days[ ymdIndex ][ 0 ] ||
					this.bookingsData.partially_booked_days[ ymdIndex ][
						resourceId
					]
				) {
					attributes.class.push( 'partial_booked' );
				}
			}

			// Calculate end date to check 'in-range' or not.
			var datePickerWrapper = this.$picker.closest(
				'.wc-bookings-date-picker'
			);
			var startDate = $.datepicker.parseDate(
				$.datepicker.ISO_8601,
				wcBookingsDatePicker.get_input_date( datePickerWrapper, '' )
			);
			var endDate;
			if ( this.$picker.data( 'is_range_picker_enabled' ) ) {
				endDate = $.datepicker.parseDate(
					$.datepicker.ISO_8601,
					wcBookingsDatePicker.get_input_date(
						datePickerWrapper,
						'to_'
					)
				);
			} else if ( startDate && numberOfDays > 1 ) {
				// We only want to do this for days, and number_of_days will
				// be 1 if the duration day is something different
				endDate = new Date( startDate );
				endDate.setDate( endDate.getDate() + ( numberOfDays - 1 ) );
			}

			// Add bookable-range CSS to all days in the range
			const inRange =
				startDate &&
				( momentDate.isSame( startDate, 'day' ) ||
					( endDate &&
						momentDate.isSameOrAfter( startDate, 'day' ) &&
						momentDate.isSameOrBefore( endDate, 'day' ) ) );

			// Add bookable-range CSS to all days in the range
			if ( inRange ) {
				attributes.class.push( 'bookable-range' );
				// Add either selection-start-date or selection-end-date CSS to the first/last day only
				if ( momentDate.isSame( startDate, 'day' ) ) {
					attributes.class.push( 'selection-start-date' );
				} else if ( momentDate.isSame( endDate, 'day' ) ) {
					attributes.class.push( 'selection-end-date' );
				}
			}
			if ( ! bookable ) {
				attributes.title = booking_form_params.i18n_date_unavailable;
				attributes.selectable = bookable;
				if ( resourceId === 0 ) {
					attributes.class.push( [
						! unavailableByRules &&
						this.bookingsData.fully_booked_days[ ymdIndex ]
							? 'fully_booked'
							: 'not_bookable',
					] );
				} else if (
					! unavailableByRules &&
					this.bookingsData.fully_booked_days[ ymdIndex ] &&
					this.bookingsData.fully_booked_days[ ymdIndex ][
						resourceId
					]
				) {
					attributes.class.push( [
						this.bookingsData.fully_booked_days[ ymdIndex ][
							resourceId
						]
							? 'fully_booked'
							: 'not_bookable',
					] );
				}
			} else {
				if ( attributes.class.indexOf( 'partial_booked' ) > -1 ) {
					attributes.title =
						booking_form_params.i18n_date_partially_booked;
				} else if ( attributes.title === '' && attributes.bookable ) {
					attributes.title = booking_form_params.i18n_date_available;
				}
				if ( ! inRange ) {
					attributes.class.push( 'bookable' );
				}
			}

			/**
			 * Filter date element attributes.
			 *
			 * @param {Object} attributes        Attributes for the date element.
			 * @param {Object} this.bookingsData Booking data.
			 * @param {Object} this.$picker      Date picker.
			 *
			 * @since 1.15.79
			 */
			attributes = HookApi().applyFilters(
				'wc_bookings_date_picker_get_day_attributes',
				attributes,
				{
					booking_data: this.bookingsData,
					custom_data: this.customData,
					date_picker: this.$picker,
					resource_id: resourceId,
					date,
				}
			);
			return attributes;
		};

	/**
	 * Creates screen reader text for all dates and appends it to the date
	 * element for better accessibility.
	 *
	 * @return {void}
	 */
	WCBookingsDatePicker.prototype.set_screen_reader_text =
		function setScreenReaderText() {
			// Find all of the date elements.
			const dateElements = document.querySelectorAll(
				'#wc-bookings-booking-form td'
			);
			const screenReaderClassName = 'screen-reader-text';
			if ( dateElements.length > 0 ) {
				dateElements.forEach( ( element ) => {
					// If the screen reader text has already been added, skip.
					if (
						element.querySelector( `.${ screenReaderClassName }` )
					) {
						return;
					}
					const screenReaderSpan = document.createElement( 'span' );
					screenReaderSpan.classList.add( screenReaderClassName );
					let dateName = '';
					let date = false;
					let day = false;
					let month = false;
					let year = false;

					// Get a list of all the class names.
					const classNames = element.classList;
					classNames.forEach( ( className ) => {
						if ( className.startsWith( 'date-day-' ) ) {
							day = className.replace( 'date-day-', '' );
						} else if ( className.startsWith( 'date-month-' ) ) {
							month = className.replace( 'date-month-', '' );
						} else if ( className.startsWith( 'date-year-' ) ) {
							year = className.replace( 'date-year-', '' );
						} else if ( className.startsWith( 'date-date-' ) ) {
							date = className.replace( 'date-date-', '' );
						}
					} );
					if ( day && month && year && date ) {
						dateName =
							wcBookingsDatePicker.monthNames[
								parseInt( month, 10 )
							] +
							' ' +
							year +
							', ' +
							wcBookingsDatePicker.dayNames[
								parseInt( day, 10 )
							];
					}

					// Append the booking status to the screen reader text.
					if ( element.classList.contains( 'fully_booked' ) ) {
						screenReaderSpan.textContent =
							dateName +
							', ' +
							booking_form_params.i18n_date_fully_booked;
					} else if (
						element.classList.contains( 'not_bookable' ) ||
						element.classList.contains( 'not-bookable' ) ||
						element.classList.contains( 'not_bookable_by_rules' )
					) {
						screenReaderSpan.textContent =
							dateName +
							', ' +
							booking_form_params.i18n_date_unavailable;
					} else if (
						element.classList.contains( 'partial_booked' )
					) {
						screenReaderSpan.textContent =
							dateName +
							', ' +
							booking_form_params.i18n_date_partially_booked;
					} else {
						screenReaderSpan.textContent = dateName;
					}

					// Find the element within the cell.
					const dateElement =
						element.querySelector( '.ui-state-default' );
					if ( dateElement ) {
						dateElement.appendChild( screenReaderSpan );
					}
				} );
			}
		};

	/**
	 * Creates or updates tooltips on bookable, not-bookable, fully booked, and partially booked date cells.
	 * Called after onUpdateDatepicker so screen-reader-text spans are already present.
	 *
	 * @return {void}
	 */
	WCBookingsDatePicker.prototype.initialize_date_tooltips =
		function initializeDateTooltips() {
			if ( ! wcBookingsTooltip ) {
				initializeBookingsTooltip();
				document.addEventListener( 'keydown', ( e ) => {
					if ( e.key === 'Escape' ) {
						hideBookingsTooltip();
					}
				} );
			} else {
				hideBookingsTooltip();
			}
			const cells = document.querySelectorAll(
				'#wc-bookings-booking-form td.not_bookable, #wc-bookings-booking-form td.not-bookable, #wc-bookings-booking-form td.not_bookable_by_rules, #wc-bookings-booking-form td.bookable, #wc-bookings-booking-form td.fully_booked, #wc-bookings-booking-form td.partial_booked, #wc-bookings-booking-form td.selection-start-date, #wc-bookings-booking-form td.bookable-range'
			);
			cells.forEach( ( cell ) => {
				const anchor = cell.querySelector( 'a' );
				const title =
					cell.getAttribute( 'title' ) ||
					( anchor && anchor.getAttribute( 'title' ) );
				if ( ! title ) {
					return;
				}
				cell.dataset.tooltipContent = title;
				if ( cell.dataset.tooltipBound ) {
					return;
				}
				cell.dataset.tooltipBound = 'true';
				const link = cell.querySelector( 'a' );
				if ( link ) {
					if ( ! link.hasAttribute( 'aria-expanded' ) ) {
						link.setAttribute( 'aria-expanded', 'false' );
					}
					link.setAttribute( 'aria-controls', 'wc-bookings-tooltip' );
				}
				cell.addEventListener( 'mouseenter', () =>
					showBookingsTooltip( cell )
				);
				cell.addEventListener( 'focusin', () =>
					showBookingsTooltip( cell )
				);
				cell.addEventListener(
					'mouseleave',
					hideBookingsTooltipWithDelay
				);
				cell.addEventListener(
					'focusout',
					hideBookingsTooltipWithDelay
				);
				cell.addEventListener( 'keydown', ( e ) => {
					if (
						e.key !== ' ' &&
						e.key !== 'Spacebar' &&
						e.code !== 'Space'
					) {
						return;
					}
					e.preventDefault();
					const targetLink = cell.querySelector( 'a' );
					if ( targetLink ) {
						targetLink.click();
					}
				} );
			} );

			// Now that tooltips are initialized, remove the title attributes to prevent
			// native browser tooltips from appearing on hover.
			document
				.querySelectorAll(
					'#wc-bookings-booking-form td[title], #wc-bookings-booking-form td a[title]'
				)
				.forEach( ( element ) => {
					element.removeAttribute( 'title' );
				} );
		};

	/**
	 * Fixes the "role" attribute of the anchor elements in the datepicker calendar.
	 *
	 * @param {Object} inst jQuery UI datepicker instance (provides inst.dpDiv for scoping).
	 * @return {void}
	 */
	WCBookingsDatePicker.prototype.fix_anchor_roles = function fixAnchorRoles(
		inst
	) {
		// inst.dpDiv is a jQuery object; use .find() to scope to the specific instance.
		const $container =
			inst && inst.dpDiv
				? $( inst.dpDiv )
				: $( '#wc-bookings-booking-form' );
		$container.find( 'td a' ).attr( 'role', 'button' );
	};
	moment.locale( wcBookingsLocale );
	wcBookingsDatePicker.init();
	// use global object added by wp_localize_script
	wc_bookings_booking_form.wc_bookings_date_picker = wcBookingsDatePicker;
} );
